<template>
  <div class="component-featured-collection row mx-0 mt-5" :style="{backgroundImage: 'url(' + fileUrl(backgroundImageUrl + imageSize()) + ')'}">
    <div class="image-shadow col px-sm-4 px-1">
      <section class="d-flex flex-column justify-content-sm-center align-items-lg-start align-items-sm-center summary">
        <h2 class="text-white mx-5">
          {{ title }}
        </h2>
        <p class="lead text-light mt-5 mx-sm-5 mx-1 ps-0 px-md-0 px-sm-5 px-1">
          {{ description }}
        </p>
        <b-button
          class="mx-5 mt-4 d-lg-none d-xxxs-inline"
          :to="url"
          variant="danger"
        >
          {{ $t('collection.featuredMoreProducts', {products: this.globalResources.productTranslation.Plural} ) }}
        </b-button>
      </section>
      <section class="d-lg-flex flex-column flex-nowrap justify-content-center w-50 d-none">
        <b-link class="mx-2 no-underline me-0 text-white mb-3 text-left" :to="url" @click="trackCollectionGaEvent">
          <small>{{ $t('common.more') }}</small>
        </b-link>
        <div style="direction: ltr;">
         <Carousel
          :rtl="$store.getters['tenantConfig/isRTL']"
          :auto-width="true"
          :margin="8"
          :loop="true"
          :rewind="true"
          :items="12"
          :dots="false">
          <ProductCard v-for="(item, index) in items" :key="index" :item="item" @click='trackGaEvent(item.id)'/>
        </Carousel>
       </div>
      </section>
    </div>
  </div>
</template>

<style>
.owl-item {
  padding-bottom: 5px;
}
</style>
<script>
import { mapGetters } from 'vuex'
import ProductsList from '@/components/ProductsList.vue'
import ProductCard from '@/components/ProductCard.vue'
import Carousel from '@/components/Carousel.vue'
import windowSize from '@/mixins/window-size'

export default {
  name: 'FeaturedCollection',
  mixins: [windowSize],
  components: {
    ProductCard,
    Carousel
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    backgroundImageUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    index:{
      type: Number,
      default:0
    }
  },
  computed: {
    ...mapGetters({
      fileUrl: 'cdn/fileUrl'
    })
  },
   methods: {
    trackGaEvent(itemId)
    {
      this.$ga.event('Collection', 'CollectionRow#'+this.index+'Click', itemId)
    },
    trackCollectionGaEvent()
    {
      this.$ga.event('Collection', 'CollectionRow#'+this.index+'Click')
    },
    imageSize()
    {
        return this.isMaxWidth480() ? '?w=720' : '?w=1440'
    }
  }
}
</script>
